// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

// --- RxJs
import { Observable } from 'rxjs';

// --- HS Code
import { environment } from '../../../environments/environment';
import { EnvService } from '../services/env.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class StandardHeadersService implements HttpInterceptor {
  constructor(private envService: EnvService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    req = req.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Client-Id': this.envService.clientId,
        'X-Version': environment.apiVersion,
      }
    });

    return next.handle(req);
  }
}
